export default __webpack_public_path__ + "static/media/TheWheelOfPainMap.5bf70b2a.jpg";